<script>
import Magnifier from "./util/Magnifier.vue";

export default {
  props: ['roster', 'structure'],
  components: {
    Magnifier
  },
  computed: {
    available_equipment() {
      return this.structure.hero.available_equipment.sort((a, b) => a.weight - b.weight);
    },
    selected_equipment() {
      return this.structure.equipment;
    }
  },
  methods: {
    equip_available(equipment) {
      const target = this.selected_equipment.find(item => item.tech_name === equipment.tech_name)
      return equipment.quantity - (target ? target.quantity : 0)
    },
    startDrag(event, item, type) {
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('tech_name', item.tech_name);
      event.dataTransfer.setData('type', type);
    },
    addEquipmentFromDrag(event) {
      const type = event.dataTransfer.getData('type');
      if(type != 'add') return;

      const tech_name = event.dataTransfer.getData('tech_name');

      this.addEquipment(tech_name);
    },
    addEquipment(tech_name) {
      const selected_equip = this.selected_equipment.find(item => item.tech_name === tech_name);

      if(selected_equip) return;

      const selected_equipment = this.structure.equipment;

      const equip = this.structure.hero.available_equipment.find(item => item.tech_name === tech_name);
      let equipment_to_add = {...equip};

      equipment_to_add.quantity = 1;
      selected_equipment.push(equipment_to_add);
      this.structure.point_cost += equipment_to_add.point_cost;
    },
    removeEquipmentFromDrag(event, _list) {
      const type = event.dataTransfer.getData('type');
      if(type != 'remove') return;

      const tech_name = event.dataTransfer.getData('tech_name');
      this.removeEquipment(tech_name);
    },
    removeEquipment(tech_name) {
      const selected_equipment = this.structure.equipment;
      const target_equipment = selected_equipment.find(item => item.tech_name === tech_name);

      target_equipment.quantity--;
      this.structure.point_cost -= target_equipment.point_cost;

      if(target_equipment.quantity == 0) {
        const index = selected_equipment.indexOf(target_equipment);
        selected_equipment.splice(index, 1);
      }
    },
  }
}
</script>

<template>
  <div class="equipment w-100">
    <div class="equipment-selected shadow-sm"
      @drop="addEquipmentFromDrag($event, 1)"
      @dragover.prevent
      @dragenter.prevent>

      <template v-for="equip in selected_equipment">
        <div class="equipment">
          <div class="equip shadow-sm"
            draggable
            @dragstart="startDrag($event, equip, 'remove')"
            @click="removeEquipment(equip.tech_name)">

            <img
              v-image-fallback
              :src="equip.image_path"
              :alt="equip.tech_name"
              class="image rounded mx-auto d-block" />

            <!-- <span>x {{ equip.quantity }}</span> -->
          </div>
        </div>
      </template>
    </div>

    <div
      class="equipment-available shadow-sm"
      @drop="removeEquipmentFromDrag($event, 1)"
      @dragover.prevent
      @dragenter.prevent>

      <template v-for="equip in available_equipment">
        <div class="equip shadow-sm"
        draggable
        @dragstart="startDrag($event, equip, 'add')"
        @click="addEquipment(equip.tech_name)"
        :class="{'disabled': equip_available(equip) == 0}"
        >
          <img
             v-image-fallback
             :src="equip.image_path"
             :alt="equip.tech_name"
             class="image rounded mx-auto d-block" />
          <p class="quantity">
            <b>{{ $t('units.cost') }}:&nbsp;<span>
              {{ equip.point_cost }}
            </span></b>
          </p>
          <magnifier :target="equip"></magnifier>
        </div>
      </template>
    </div>
  </div>
</template>
